import { GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP } from "../ghg-administration/methodology-lookup";
import { GPC_METHODOLOGY_LOOKUP_MAP } from "../gpc/methodology-lookup";
const buildScopeByEnergySourceId = (lookup) => {
    const map = new Map();
    for (const sector of Object.values(lookup.sectors)) {
        for (const es of Object.values(sector.energySources ?? {})) {
            if (es.scope !== undefined) {
                map.set(es.id, es.scope);
            }
        }
    }
    return map;
};
const GPC_SCOPE_BY_ENERGY_SOURCE_ID = buildScopeByEnergySourceId(GPC_METHODOLOGY_LOOKUP_MAP);
const ADMINISTRATION_SCOPE_BY_ENERGY_SOURCE_ID = buildScopeByEnergySourceId(GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP);
/**
 * Best-effort default scope (1, 2 or 3) for a GPC row given its energy source.
 *
 * **Not authoritative.** The GPC protocol (v7) allows the same energy source to
 * appear under multiple scopes — most importantly grid electricity, which is
 * scope 2 for the consumed kWh AND scope 3 for the Transmission & Distribution losses on top. So an
 * energySourceId alone cannot uniquely determine scope. Callers that know the
 * intended scope (UI, scenario engine, future Transmission & Distribution loss flows) must pass it
 * explicitly; this helper is the fallback when nothing else is known and for
 * backfilling historical rows that pre-date explicit scope.
 *
 * Returns null when:
 *   - no energySourceId is provided (e.g. GPC waste direct-emission rows — caller
 *     supplies scope explicitly in that case),
 *   - the inventory is neither GPC nor administration (BISKO has no scope concept by design),
 *   - the energy source is not in the GPC lookup.
 *
 * The mapping is sourced from GPC_METHODOLOGY_LOOKUP_MAP. The Prisma backfill
 * migration mirrors this same mapping; if you change one, change the other.
 */
export const deriveScopeFromEnergySource = (energySourceId, methodologyId) => {
    if (!energySourceId)
        return null;
    if (methodologyId === GPC_METHODOLOGY_LOOKUP_MAP.id)
        return GPC_SCOPE_BY_ENERGY_SOURCE_ID.get(energySourceId) ?? null;
    if (methodologyId === GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP.id)
        return ADMINISTRATION_SCOPE_BY_ENERGY_SOURCE_ID.get(energySourceId) ?? null;
    return null;
};
